import InboxService from '@/services/InboxService';

let interval = null;
let currentParams = null;

const state = {
  formSubmittedData: {
    buyCount: 0,
    sellCount: 0,
    afsCount: 0,
  },
  loading: false,
  error: null,
};

const mutations = {
  SET_FORM_SUBMITTED_DATA(state, data) {
    state.formSubmittedData = data;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchFormSubmitted({ commit }, params) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const data = await InboxService.getFormSubmitted(params);
      commit('SET_FORM_SUBMITTED_DATA', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  initFormSubmittedPolling({ dispatch }, params) {
    currentParams = params;

    dispatch('fetchFormSubmitted', currentParams);
    if (!interval) {
      interval = setInterval(() => {
        if (document.hidden) return;
        if (currentParams) {
          dispatch('fetchFormSubmitted', currentParams);
        }
      }, 30000);
    }
  },

  stopFormSubmittedPolling() {
    if (interval) {
      clearInterval(interval);
      interval = null;
      currentParams = null;
    }
  },
};

const getters = {
  formSubmittedSummary: (state) => state.formSubmittedData,
  isFormSubmittedLoading: (state) => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
